import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  Button,
  TableContainer,
  TableHeader,
} from "@windmill/react-ui";
import { useState, useEffect, useContext } from "react";
import { Tabs, Tab } from "@mui/material";

import ExportDataXlsx from "components/common/ExportDataXlsx";
import VendorAllotTable from "components/vendor/VendorAlotTable";

import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import VendorAlot from "services/VendorAlotServices";
import VendorAlotDrawer from "components/drawer/VendorAlotDrawer";
import sidebar from "routes/sidebar";
import MainDrawer from "components/drawer/MainDrawer";
import Somethingwentwrong from "pages/Somethingwentwrong";
import DeleteModal from "components/modal/DeleteModal";
import { SidebarContext } from "context/SidebarContext";
import { FiRefreshCcw } from "react-icons/fi";
import { useLocation } from "react-router-dom";

const VendorAlotment = () => {
  const location = useLocation();

  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  // const { toggleDrawer } = useContext(SidebarContext);
  const [vendorsalot, setVendorAlot] = useState([]);

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0); // Tab state
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [error, setError] = useState(false);
  const { setIsUpdate, isUpdate } = useContext(SidebarContext);
  const [status, setStatus] = useState(false);
  const {
    vendoralotRef,
    dataTable,
    serviceData,
    handleSubmitVendorAlot,
    currentPage,
  } = useFilter(vendorsalot, itemsPerPage);
  useEffect(() => {
    if (serviceData && serviceData.length > 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const [exportingData, setExportingData] = useState([]);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const parseDate = (str) => {
    if (!str) return null;
    const [dd, mm, yyyy] = str.split("-");
    const date = new Date(yyyy, mm - 1, dd);
    return isNaN(date.getTime()) ? null : date;
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlType = params.get("type");
    if (urlType) {
      const parsed = Number(urlType);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 4) {
        setTab(parsed - 1);
      }
    }
    const start = params.get("start");
    const end = params.get("end");

    const startDate = parseDate(start);
    const endDate = parseDate(end);

    if (startDate) {
      setSearchStartDate((prev) =>
        prev?.getTime() === startDate.getTime() ? prev : startDate,
      );
    }

    if (endDate) {
      setSearchEndDate((prev) =>
        prev?.getTime() === endDate.getTime() ? prev : endDate,
      );
    }
  }, [location.search]);

  useEffect(() => {
    const fetchBookings = async () => {
      setLoading(true);
      try {
        var payload = {};

        if (tab + 1 === 1) {
          payload.type = 1;
        } else if (tab + 1 === 2) {
          payload.type = 2;
        } else {
          payload.type = 3;
        }

        payload.id_employee = id_employee;
        payload.start_date = searchstartDate ? formatDate(searchstartDate) : "";
        payload.end_date = searchendDate ? formatDate(searchendDate) : "";

        const response = await VendorAlot.getVendorAlotList(payload);

        const updatedData =
          response?.data?.map(
            ({
              id,
              vendor_id,
              vendor_name,
              driver_name,
              added_date,
              status,
              ...rest
            }) => ({
              id,
              vendor_id,
              vendor_name,
              driver_name,
              added_date,
              status,
              ...rest,
            }),
          ) || [];

        setVendorAlot(updatedData);
        setStatus(response?.status);
      } catch (error) {
        setError(true);
      } finally {
        setLoading(false);
        setIsUpdate(false);
      }
    };
    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      return;
    }

    fetchBookings();
  }, [
    tab,
    isUpdate,
    searchstartDate,
    searchendDate,
    id_employee,
    location.search,
    setIsUpdate,
  ]);

  useEffect(() => {
    const finalData =
      dataTable?.map((item, index) => {
        const presentAllotment = item.allotment_history?.find(
          (i) => i?.status === "Present",
        );

        return {
          "SI.No": index + 1,
          "Reference No": item.ref_no || "-",
          "Client Name": item.client_name || "-",
          "No.of days": item.no_of_days || "-",
          "Start Date": item.start_date || "-",
          "End Date": item.end_date || "-",
          "Arrival City": item.arrival_name || "-",
          "Departure City": item.departure_name || "-",
          "Tour Type": item.package_type || "-",
          "Vehicle Name": item.vehiclename || "-",

          "Vendor Name": presentAllotment?.vendor_name || "-",

          "Franchise Name": presentAllotment?.franchise_name || "-",

          "Travel date":
            presentAllotment?.va_start_date && presentAllotment?.va_end_date
              ? `${presentAllotment.va_start_date} - ${presentAllotment.va_end_date}`
              : presentAllotment?.va_start_date || "-",

          Status: item.vendor_status || "-",
        };
      }) || [];

    setExportingData(finalData);
  }, [dataTable]);
  const handleTabChange = (_event, newValue) => {
    setTab(newValue);
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };

  const handleRefresh = () => {
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
  };

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vendor allotment" && perm.view === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vendor allotment" && perm.add === 1,
      );
        const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vendor allotment" && perm.edit === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vendor allotment" && perm.export === 1,
      );

  const getTabName = () => {
    if (tab === 0) return "UnAlloted";
    if (tab === 1) return "Alloted";
    if (tab === 2) return "All";
    return "";
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={null} title="" />
          <MainDrawer>
            <VendorAlotDrawer id={null} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="Start Date" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="Between" />
                    <div className="w-50">
                      <InputSearchDate
                        min={searchstartDate}
                        value={searchendDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={vendoralotRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitVendorAlot}
                  />
                </div>

                {hideExport && (
                  <ExportDataXlsx
                    title="vendorsalot"
                    exportDataXlsx={exportingData}
                    fileNames={`Vendor_${getTabName()}`}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                )}

                <div>
                  <Button
                    className="rounded-md h-10 px-8"
                    onClick={() => {
                      handleSearch();
                    }}
                  >
                    Search
                  </Button>
                </div>
                <div>
                  <FiRefreshCcw
                    onClick={() => {
                      handleRefresh();
                    }}
                    cursor="pointer"
                  />
                </div>
              </div>
            </CardBody>
          </Card>
          {/* Tabs */}
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="UnAlloted"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Alloted"
            />
            <Tab
              className="focus:outline-none dark:text-white"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="All"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length ? (
              <TableContainer
                style={{
                  maxHeight: "65vh",
                  overflow: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header text-center capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell>Sl.No.</TableCell>
                      <TableCell>Booking Id</TableCell>
                      <TableCell>Client Name</TableCell>
                      <TableCell>Trip Date</TableCell>

                      <TableCell>No of Days</TableCell>
                      <TableCell>vehicle type</TableCell>
                      <TableCell>Start/End City</TableCell>
                      <TableCell>Tour Type</TableCell>
                      <TableCell>Itinerary Details</TableCell>

                      {(tab === 0 || tab === 1 || tab === 2) && (
                        <TableCell>Franchise Name</TableCell>
                      )}

                      {(tab === 0 || tab === 1 || tab === 2) && (
                        <TableCell>Vendor Name</TableCell>
                      )}

                      {(tab === 0 || tab === 1 || tab === 2) && (
                        <TableCell>Travel date</TableCell>
                      )}

                      <TableCell>Remarks</TableCell>

                      <TableCell>vehicle Name</TableCell>
                      <TableCell>Vehicle Note</TableCell>
                      <TableCell>Trip Status</TableCell>
                      {tab === 0 && <TableCell>Allot</TableCell>}
                      {tab === 1 && <TableCell>Modify</TableCell>}
                      {tab === 2 && <TableCell>Status</TableCell>}
                    </tr>
                  </TableHeader>
                  <VendorAllotTable
                    vendoralot={dataTable}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    tab={tab}
                    hideAdd={hideAdd}
                    hideEdit={hideEdit}
                  />
                </Table>
                {/* <TableFooter>
                <div className="py-3 flex gap-4 items-center justify-between">
                  <div className="flex-2">
                    <Pagination
                      totalResults={totalResults}
                      resultsPerPage={resultsPerPage}
                      onChange={handleChangePage}
                      label="Table navigation"
                    />
                  </div>
                  <div className="w-40">
                    <Select
                      value={itemsPerPage}
                      onChange={(event) => setItemsPerPage(event.target.value)}
                    >
                      <option value={10}>10 per page</option>
                      <option value={20}>20 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                      <option value={vendorsalot.length}>Show All</option>
                    </Select>
                  </div>
                </div>
              </TableFooter> */}
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Bookings." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default VendorAlotment;
